import { render, staticRenderFns } from "./ChannelAccessModal.vue?vue&type=template&id=302e5ffa&"
import script from "./ChannelAccessModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelAccessModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports